import styled from 'styled-components'
import { theme, Row, Box, Input } from '@/client/components'
const { borders, color, font, space, breakpoint } = theme

export const marginSet = `
margin-bottom: 1rem;
`
export const TileBlockWrapper = styled.div`
  padding: 2rem 0;
  display: flex;
  align-items: center;
  background: & .guide-col {
    margin-bottom: 1rem;
  }

  @media (min-width: ${breakpoint.hd}) {
    & .guide-col {
      margin-bottom: 0;
    }
  }
  & .tileblock-full {
    width: 100%;
    background: ${color.grayscale.lighter};
    padding: 4rem 0;
  }
`

export const FBBlocks = styled.div`
  & .fb-block {
    margin-bottom: 2.5rem;
    @media (min-width: ${breakpoint.xl}) {
      margin-bottom: 0;
      border-right: 1px solid ${color.grayscale.lightAlpha};
    }
    &:last-child {
      @media (min-width: ${breakpoint.xl4}) {
        border: none;
      }
    }
  }
`
export const FBHead = styled.div`
  border-bottom: 1px solid ${color.grayscale.lightAlpha};
  ${marginSet}
  @media (min-width: ${breakpoint.xl4}) {
    min-height: 250px;
  }

  & .block-p {
    font-size: ${font.size.xsmall};
  }
`
export const FBBody = styled.div`
  & .block-p {
    font-size: ${font.size.xsmall};
  }
`
export const FBIconSet = styled.div`
  font-size: ${font.size.small};
  ${marginSet}

  & .FBIcon {
    padding-right: 0.5rem;
  }
`

export const FBIconRow = styled.div`
  font-size: ${font.size.xsmall};
  display: flex;
  & p {
    margin: 0;
  }
`
export const IconBox = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.5rem;
`
